// extracted by mini-css-extract-plugin
export var active = "_i8-2";
export var recordingDot = "_i8-1";
export var recordingIndicator = "_i8-0";